import React from "react";
import OptimizedDashboard from "../../components/OptimizedDashboard";

const Dashboard: React.FC = () => {
  return <OptimizedDashboard />;
};

export default Dashboard;